import { ApiOrgProduct } from '@kaiizen/kai-pro-api';
import { FlyOut } from '../../Widgets';
import { OrgProductDetails } from '../OrgProductDetails';

export const OrgProductFlyout = ({
  orgProduct,
  open,
  onClose,
}: {
  orgProduct: ApiOrgProduct | null;
  open: boolean;
  onClose: () => void;
}) => {
  if (!orgProduct) return null;

  return (
    <FlyOut
      open={open}
      flyOutClosed={onClose}
      title='Product Details'
    >
      <OrgProductDetails orgProduct={orgProduct} />
    </FlyOut>
  );
};
